<template>
	<div class="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-6">
		<div class="text-center max-w-md">
			<h1 class="text-7xl font-extrabold text-primary mb-4">{{ title }}</h1>
			<h2 class="text-2xl font-semibold mb-2">{{ message }}</h2>
			<p class="text-muted-foreground mb-6">{{ description }}</p>
			<RouterLink to="/" class="inline-block bg-primary text-primary-foreground px-6 py-3 rounded-lg shadow hover:opacity-90 transition">
			Go back Home
			</RouterLink>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { ref, computed } from 'vue'

const route = useRoute();

const title = computed(() => {
	if (route.meta.type === '403') return '403';
	if (route.meta.type === '404') return '404';
	return 'Error';
});

const message = computed(() => {
	if (route.meta.type === '403') return 'Permission Denied';
	if (route.meta.type === '404') return 'Page Not Found';
	return 'Something went wrong';
});

const description = computed(() => {
	if (route.meta.type === '403') return 'You do not have permission to access this page.';
	if (route.meta.type === '404') return "Oops! The page you're looking for doesn't exist or has been moved.";
	return 'An unexpected error occurred.';
});
</script>

